const routers = [

    {
        path: '/customer/registerApply',
        name: 'CustomerApply',
        component: resolve => require(['../views/customer/CustomerApply'], resolve)
    },
    {
        path:'/customer/customerList',
        name: 'CustomerList',
        component: resolve => require(['../views/customer/CustomerList'], resolve)
    },
    {
      path:'/customer/rivatizationDeployment',
      name: 'RivatizationDeployment',
      component: resolve => require(['../views/customer/RivatizationDeployment'], resolve)
    },
  {
    path:'/customer/customSituation',
    name: 'CustomSituation',
    component: resolve => require(['../views/customer/CustomSituation'], resolve)
  },
  {
    path:'/customer/suggestion',
    name: 'Suggestion',
    component: resolve => require(['../views/customer/Suggestion'], resolve)
  }

]
export default routers



// WEBPACK FOOTER //
// ./src/routers/customer.js